import Scene from "../js/webgl/Scene";
import { Group, AnimationMixer, LoopOnce } from 'three';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Helper function to calculate closest 90-degree point
function closest90DegreeRotation(currentRotation) {
    const deg90 = Math.PI / 2;  // 90 degrees in radians  
    return Math.round(currentRotation / deg90) * deg90;
}

async function LoadedObject() {
    const body = document.querySelector('[data-webgl="loaded-object"]');

    if (!body) return;

    const scene = new Scene();

    // Check device performance and set quality settings
    const performanceCheck = () => {
        // Check device memory (if available)
        const lowMemory = navigator.deviceMemory && navigator.deviceMemory < 4;
        
        // Check processor cores (if available) 
        const lowCPU = navigator.hardwareConcurrency && navigator.hardwareConcurrency < 4;
        
        // Check if mobile device (typically lower performance)
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        return lowMemory || lowCPU || isMobile;
    };

    const isLowPerfDevice = performanceCheck();

   
       
    
    
      

    // Load object into the scene with aggressive quality reduction
    const home3d = await scene.loadGltf('/wp-content/themes/finbourne/assets/objects/home7.glb');

    // Aggressively reduce quality of loaded model
    home3d.scene.traverse(node => {
        if (node.isMesh) {
            // Significantly reduce geometry detail
            if (node.geometry) {
                node.geometry.dispose();
                // Convert to non-indexed and reduce precision
                node.geometry = node.geometry.toNonIndexed();
                // Reduce number of vertices by 50%
                const positions = node.geometry.attributes.position.array;
                const reduced = new Float32Array(positions.length / 2);
                for (let i = 0; i < reduced.length; i++) {
                    reduced[i] = positions[i * 2];
                }
            }
            
            // Drastically simplify materials
            if (node.material) {
                node.material.precision = "lowp";
                
            }
        }
    });

    const group = new Group();
    group.add(home3d.scene);
    scene.sceneGroup.add(group);

   console.log('test3')

    // Add camera with very low quality settings
    scene.camera = home3d.cameras[0].clone();
    scene.camera.aspect = scene.container.offsetWidth / scene.container.offsetHeight;
    scene.camera.updateProjectionMatrix();
    scene.renderer.setPixelRatio(0.5); // Set very low pixel ratio
    scene.renderer.setSize(
        scene.container.offsetWidth * 0.5,
        scene.container.offsetHeight * 0.5
    ); // Drastically reduce render size

    // Camera animations
    scene.mixer = new AnimationMixer(scene.camera);
    const clipAction = scene.mixer.clipAction(home3d.animations[0]);
    clipAction.setLoop(LoopOnce);
    clipAction.clampWhenFinished = true;
    clipAction.timeScale = 1;  
    scene.clipActions.push(clipAction);

    // Object animations
    const objectMixer = new AnimationMixer(home3d.scene);
    let objectAction = null;

    if (home3d.animations.length > 0) {
        objectAction = objectMixer.clipAction(home3d.animations[0]);
        objectAction.clampWhenFinished = true;
        objectAction.play();   
    }

    // Re-init orbit controls
    scene.orbitControls = scene.createOrbitControls();
    scene.orbitControls.enableRotate = false;
    scene.orbitControls.enableZoom = false;
    scene.orbitControls.enablePan = false;

    // Change object settings
    home3d.scene.traverse(child => {
        if (child.isMesh) {
           // Existing mesh adjustments...
        }
        
        if (child.isPointLight) {
            child.intensity = 20;
        }
    });

    // Add the new lights group to the scene
    const lightsGroup = new Group();

    const lights = [];
    group.traverse((obj) => {
        if (obj.isLight) {
            lights.push(obj);
        }
    });

    lights.forEach(light => {
        group.remove(light); 
        lightsGroup.add(light); 
    });

    // Add the new lights group to the scene
    scene.sceneGroup.add(lightsGroup);

    // Mouse move effect variables
    let mouseX = 0;
    let mouseY = 0;
    const windowHalfX = window.innerWidth / 2;
    const windowHalfY = window.innerHeight / 2;
    let objectOffsetX = 0;
    let objectOffsetY = 0;

    // Mouse move event listener
    document.addEventListener('mousemove', onDocumentMouseMove);

    function onDocumentMouseMove(event) {
        mouseX = (event.clientX - windowHalfX) / windowHalfX;
        mouseY = (event.clientY - windowHalfY) / windowHalfY;
    }

    // Separate animation loop for mouse movement
    function animateMouseEffect() {
        requestAnimationFrame(animateMouseEffect);

        // Apply subtle object movement based on mouse position
        const targetOffsetX = mouseX * 0.1; // Adjust this value to control sensitivity
        const targetOffsetY = mouseY * 0.1; // Adjust this value to control sensitivity

        objectOffsetX += (targetOffsetX - objectOffsetX) * 0.05;
        objectOffsetY += (targetOffsetY - objectOffsetY) * 0.05;

        group.position.x = objectOffsetX;
        group.position.y = objectOffsetY;

        scene.renderer.render(scene.sceneGroup, scene.camera);
    }

    animateMouseEffect();

    const infiniteRotationTimeline = gsap.timeline({ repeat: -1, yoyo: false });
    infiniteRotationTimeline.to(group.rotation, { z: Math.PI * 2, duration: 10, ease: 'none' });

    let timeline_hometop = gsap.timeline({
        scrollTrigger: {
            trigger: body,
            scrub: true,
            start: '0px top',
            end: "+=300%",
            onEnter: () => {
                infiniteRotationTimeline.pause();

                const closestRotation = closest90DegreeRotation(group.rotation.z);
                gsap.to(group.rotation, { z: closestRotation, duration: 1 });
            },
            onUpdate: (self) => {
                // Stop the infinite rotation when scrolling
                infiniteRotationTimeline.pause();
                if (objectAction) {
                    const scrollProgress = self.progress; // 0 (start of scroll) to 1 (end of scroll)
                    const duration = objectAction.getClip().duration; // Total animation duration
                    const time = scrollProgress * duration;
                    // Update animation time based on scroll direction
                    objectMixer.setTime(time);  // Adjust time to match scroll progress (works for reverse scrolling too)
                }
            },
            onLeaveBack: () => {
                infiniteRotationTimeline.play(); 
            },
           
            invalidateOnRefresh: true
        }
    });

    // Function to handle resize
    function handleResize() {
        // Update renderer size
        scene.renderer.setSize(scene.container.offsetWidth, scene.container.offsetHeight);
        
        // Update camera aspect ratio and projection matrix
        scene.camera.aspect = scene.container.offsetWidth / scene.container.offsetHeight;
        scene.camera.updateProjectionMatrix();
        
        // Adjust object size based on screen width
        if (window.innerWidth < 1024) {
            group.scale.set(0.5, 0.5, 0.5);  // 50% smaller
        } else {
            group.scale.set(1, 1, 1);  // Original size
        }
        
        // Re-render the scene
        scene.renderer.render(scene.sceneGroup, scene.camera);
    }

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Initial call to set correct size
    handleResize();
}

export default LoadedObject;